var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiabetes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 378,
    viewBox: "0 0 365 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M284 219.674H283.33C277.969 219.674 273.076 217.654 269.36 214.339C268.856 214.662 268.337 214.971 267.789 215.251C265.159 216.586 262.341 217.278 259.564 217.627C256.166 228.236 245.465 236.005 232.816 236.005H199.149C194.985 236.005 191.609 232.631 191.609 228.469C191.609 224.307 194.985 220.935 199.149 220.935H232.816C239.873 220.935 245.614 216.224 245.614 210.435C245.614 204.648 239.873 199.937 232.816 199.937H161.232V235.192C161.232 240.943 162.103 270.396 179.27 285.621C185.331 290.994 192.559 293.961 200.836 294.488V316.464C200.836 320.626 204.212 324 208.377 324H278.067C282.231 324 285.607 320.626 285.607 316.464V293.216C296.801 289.994 305 279.786 305 267.726V198.688C305 210.259 295.579 219.674 284 219.674Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M234.741 184.933V146.392H222.233V184.867H232.816C233.463 184.867 234.104 184.893 234.741 184.933Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M262.331 146.392H249.823V190.196C254.178 193.282 257.512 197.52 259.281 202.412C262.327 201.699 262.331 200.249 262.331 198.354V146.392Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M289.919 152.922C289.919 149.321 286.987 146.392 283.384 146.392H277.41V198.687C277.41 201.949 280.067 204.604 283.331 204.604H283.999C287.262 204.604 289.919 201.949 289.919 198.687V152.922Z",
    fill: "#6C6969"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M185.696 113.27V184.867H207.154V94.2999C207.154 88.389 202.34 83.5787 196.426 83.5787C190.509 83.5787 185.696 88.389 185.696 94.2999V98.1985H162.985C159.816 84.3588 147.405 74 132.61 74H62.5406C58.3762 74 55 77.3741 55 81.5359V129.933C55 134.093 58.3762 137.467 62.5406 137.467H132.61C147.405 137.467 159.816 127.108 162.985 113.27H185.696ZM136.841 105.734C136.841 109.896 133.465 113.27 129.301 113.27H85.2082C81.0438 113.27 77.6676 109.896 77.6676 105.734C77.6676 101.573 81.0438 98.1985 85.2082 98.1985H129.301C133.465 98.1985 136.841 101.573 136.841 105.734Z",
    fill: "#6C6969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 51,
    y: 74,
    width: 258,
    height: 258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white",
    transform: "translate(55 74)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes);
export default __webpack_public_path__ + "static/media/Diabetes.dd359e5b4454768107cb4bdd44fd3107.svg";
export { ForwardRef as ReactComponent };